export default <T, F extends (item: T) => string | number>(
  array: T[],
  propOrGetter: keyof T | F,
  order: 'asc' | 'desc' = 'asc',
): T[] => {
  const getter = typeof propOrGetter === 'string'
    ? ((item: T) => item[propOrGetter] as string | number) as F
    : propOrGetter as F;
  return array.sort((a, b) => {
    const aProp = getter(a);
    const bProp = getter(b);
    if (aProp < bProp) {
      return order === 'asc' ? -1 : 1;
    }
    else if (aProp > bProp) {
      return order === 'asc' ? 1 : -1;
    }

    return 0;
  });
};
